/**
 * Raw SVG strings for each app's icon, imported once and shared across
 * the site. Vite's `?raw` import returns the file content verbatim — we
 * render via `dangerouslySetInnerHTML` so we get full fidelity (gradients,
 * paths, the lot) without parsing.
 */
import stickies from "../assets/icons/stickies.svg?raw";
import notes from "../assets/icons/notes.svg?raw";
import music from "../assets/icons/music.svg?raw";
import movies from "../assets/icons/movies.svg?raw";
import calculator from "../assets/icons/calculator.svg?raw";
import browser from "../assets/icons/browser.svg?raw";
import kepler from "../assets/icons/kepler.svg?raw";
import layouts from "../assets/icons/layouts.svg?raw";
import settings from "../assets/icons/settings.svg?raw";

export const APP_ICONS = {
  stickies,
  notes,
  music,
  movies,
  calculator,
  browser,
  kepler,
  layouts,
  settings,
} as const;

export type AppIconKey = keyof typeof APP_ICONS;
